module.exports = __webpack_public_path__ + "static/img/m2.246b875.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/mobile/m2.png
// module id = AiSr
// module chunks = 12